import {useMemo} from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {Typography} from "@mui/material";
import s from './docs.module.css'

import ArrayExcelSaver from "../ArrayExcelSaver";

export default function ReportTable(props) {
  const { data, disableFull = false, disableShort = false } = props;

  /** Именно эта ф-ция принимает решение в какой цвет красить ячейку в зависимости от отклонения времени от эталона */
  const coloriser = (timeSec) => {
    if (timeSec === 28800) {
      return { backgroundColor: "#70AD47" };
    } else if (timeSec < 28800 && timeSec >= 27360) {
      return { backgroundColor: "#FFE799" };
    } else if (timeSec < 27360) {
      return { backgroundColor: "#FF0000" };
    } else if (timeSec > 28800 && timeSec <= 30240) {
      return { backgroundColor: "#A9D18D" };
    } else if (timeSec > 30240) {
      return { backgroundColor: "#ED7D31" };
    }
    return undefined;
  };
  //краткий табель
  const shortTableData = useMemo(() => {
    return data.map((item, i) => {
      const { name = "", columns = [], rows = [] } = item;

      if (i === 0) {
        return ["", ...columns.map(({ value }) => value)];
      } else {
        const tmpArr = rows?.[0]?.rowValues || [];
        return [name, ...tmpArr.map(({ value }) => value)];
      }
    });
  }, [data]);

  //Длиный табель
  const fullTableData = useMemo(() => {
    let result = [];

    data.forEach((item, i) => {
      const { name = "", columns = [], rows = [] } = item;
      if (i === 0) {
        result = [...result, ["", "", ...columns.map(({ value }) => value)]];
      } else {
        const trackerData = rows.map(({ rowName = "", rowValues = [] }, j) => [
          j === 0 ? name : "",
          rowName,
          ...rowValues.map(({ value }) => value),
        ]);
        result = [...result, ...trackerData];
      }
    });
    return result;
  }, [data]);

  if (!data.length) return null;
  const [tableHeader, ...tableData] = data;

  let header = "Табель рабочего времени за ";
  let sHeader = "Краткий табель рабочего времени за ";
  if (tableHeader?.columns?.length === 2) {
    header += `${tableHeader.columns[0]?.value}`;
    sHeader += `${tableHeader.columns[0]?.value}`;
  } else if (tableHeader?.columns?.length > 2) {
    const lastDate = data[0].columns.length - 2;
    header += `${tableHeader.columns[0]?.value} - ${tableHeader.columns[lastDate]?.value}`;
    sHeader += `${tableHeader.columns[0]?.value} - ${tableHeader.columns[lastDate]?.value}`;
  }

  return (
    <>
      {disableShort ? null : (
        <>
          <div className={s.tableContainer}>
            <Typography className={s.tableTitle} sx={{paddingLeft: "10px"}} gutterBottom>
              <ArrayExcelSaver
                data={shortTableData}
                name={sHeader}
                description="Табель"
              />
              {sHeader}
            </Typography>
            <TableContainer
              component={Paper}
              sx={{
                width: "100%",
                marginBottom: "40px",
              }}
            >
              <Table>
                <TableHead sx={{ backgroundColor: "rgba(104, 154, 219, 0.2)" }}>
                  <TableRow>
                    <TableCell>&nbsp;</TableCell>
                    {tableHeader?.columns?.map(({ value }) => (
                      <TableCell className={`${s.textAlignRight} ${s.tableHeader}`}>{value}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map(({ name, rows }, index) => {
                    return rows?.length ? (
                      <TableRow key={index}>

                        <TableCell className={s.tableBody}>{name} </TableCell>

                        {rows[0]?.rowValues?.map(
                          ({ value }) => (
                            <TableCell className={`${s.textAlignRight}  ${s.tableBody}`}>
                              {value}
                            </TableCell>
                          )
                        )}
                      </TableRow>
                    ) : null;
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>
      )}

      {disableFull ? null : (
        <div className={s.tableContainer}>
            <Typography gutterBottom>
              <ArrayExcelSaver
                data={fullTableData}
                name={header}
                description="Табель"
              />
              {header}
            </Typography>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table>
                <TableHead sx={{ backgroundColor: "rgba(104, 154, 219, 0.2)" }}>
                  <TableRow>
                    <TableCell>&nbsp;</TableCell>
                    <TableCell>&nbsp;</TableCell>
                    {tableHeader?.columns?.map(({ value }) => (
                      <TableCell>{value}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map(({ name, rows }, i) => {
                    return rows.map(({ rowName, rowValues }, j) => (
                      <TableRow
                        key={`${i}_${j}`}
                        sx={
                          j === 0
                            ? { backgroundColor: "rgba(104, 154, 219, 0.2)" }
                            : undefined
                        }
                      >
                        {j === 0 ? (
                          <TableCell rowSpan={rows?.length}>{name}</TableCell>
                        ) : null}

                        <TableCell>{rowName}</TableCell>

                        {rowValues.map(({ value, rawValue }, rIndex) => (
                          <TableCell
                            sx={
                              j === 0 && rIndex !== rowValues.length - 1
                                ? coloriser(rawValue)
                                : undefined
                            }
                          >
                            {value}
                          </TableCell>
                        ))}

                      </TableRow>
                    ));
                  })}
                </TableBody>
              </Table>
            </TableContainer>
        </div>
      )}
    </>
  );
}
